<template>
	<div class="cotent">
		<div class="content_top">
			<img src="@/assets/images/appliction/banner.jpg" alt="" class="w100">
			<!-- <h3>Bulk Material Handling</h3> -->
		</div>
		<div class="content_center">
			<div class="container">
				<div class="text_box">
					<h3>Bulk Material Handling</h3>
					<p>
						{{category.description}}
					</p>
				</div>
				<div class="swiper-container">
				    <div class="swiper-wrapper">
				        <div class="swiper-slide" v-for="(item,index) in lbList" :key="index">
				           <img class="w100" :src="item.imgsrc" alt="">
							
				        </div>
						
				    </div>
				    <div class="swiper-pagination" slot="pagination">
						
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import axios from 'axios';
	
	import Swiper from 'swiper';
	export default {
		data() {
			return {
				cid:6,
				category:'',
				lbList:[
					{
						imgsrc:require('@/assets/images/appliction/bulkmaterial/1.jpg'),
					},
				    {
						imgsrc:require('@/assets/images/appliction/bulkmaterial/2.jpg'),
					},
				    {
						imgsrc:require('@/assets/images/appliction/bulkmaterial/3.jpg'),
					},
				    {
						imgsrc:require('@/assets/images/appliction/bulkmaterial/4.jpg'),
					},
				    {
						imgsrc:require('@/assets/images/appliction/bulkmaterial/5.jpg'),
					},
				    {
						imgsrc:require('@/assets/images/appliction/bulkmaterial/6.jpg'),
					},
				    
				   
				    
				],
			}
		},
		mounted(){
			var that = this;
			axios({
				method: 'post',
				url:`${this.$apiYf}/artilecategoryapi.php`,
				data: {
					cid:that.cid
				},
				headers: {'Content-Type': 'multipart/form-data'},
			}).then((res) =>{
				that.category=res.data.category
			    
			})
			this.$nextTick(() => {
				this.lbSwiper = new Swiper ('.swiper-container', {
					loop: true, 
					autoplay:true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					autoHeight:true,
					centeredSlides: true,
					slidesPerView: "auto",
					speed: 500,
					roundLengths : true, 
					observer:true,
					observeParents:true,
					observeSlideChildren:true,
					calculateHeight: true,
					
				});
			})
		}
	}
</script>

<style lang="scss">
	.content_center{
		.container{display: flex;margin: 5vw auto 3vw;align-items: flex-start;
			.text_box{width: 40%;margin-right: 5%;
				h3{font-size: 48px;color: #0c4fa2;margin-bottom: 44px;
					position: relative;line-height: 1.8;
					&::after{
						content: '';
						border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
					}
				}
			}
		}
		.swiper-container {
		    flex:1; overflow: hidden; position: relative;
		    .swiper-wrapper {
		        width: 100%; 
		        .swiper-slide {
		            width: 80%;overflow: hidden;margin: 0 1%;
					
					
		        }
		    }
			
			
		    .swiper-pagination {
		        text-align: center;position: relative;bottom: 0;margin-top: 10px;
		        span.swiper-pagination-bullet {
		            width: 20px; height: 5px;border-radius:0;  opacity: 1;background:#aaa;display: inline-block;
		            &.swiper-pagination-bullet-active {
		                background:#333; 
		            }
		        }
		    }
		    
			
			
		}
	}

</style>